import React from 'react';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import WarningIcon from '@mui/icons-material/Warning';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import HourglassBottomIcon from '@mui/icons-material/HourglassBottom';
import RadioButtonCheckedIcon from '@mui/icons-material/RadioButtonChecked';
import PendingIcon from '@mui/icons-material/Pending';
import CancelIcon from '@mui/icons-material/Cancel';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import EmailIcon from '@mui/icons-material/Email';
import MarkEmailReadIcon from '@mui/icons-material/MarkEmailRead';
import UnsubscribeIcon from '@mui/icons-material/Unsubscribe';
import TouchAppIcon from '@mui/icons-material/TouchApp';
import EditIcon from '@mui/icons-material/Edit';
import SmsIcon from '@mui/icons-material/Sms';
import { green, red, orange, blue, grey } from '@mui/material/colors';

export const getPercentage = (value, total) => {
  if (!total || total === 0) return '0%';
  return `${Math.round((value / total) * 100)}%`;
};

export const formatCampaignDate = (dateValue) => {
  if (!dateValue) return '';
  try {
    return new Date(dateValue).toLocaleString();
  } catch {
    return '';
  }
};

const iconSx = { marginRight: '5px' };

export const getEmailCampaignStatusIcon = (status) => {
  switch (status) {
    case 'pending':
      return <PendingIcon sx={{ color: grey[500], ...iconSx }} />;
    case 'sending':
      return <HourglassBottomIcon sx={{ color: orange[500], ...iconSx }} />;
    case 'sent':
      return <CheckCircleIcon sx={{ color: green[500], ...iconSx }} />;
    case 'delivered':
      return <EmailIcon sx={{ color: blue[500], ...iconSx }} />;
    case 'opened':
      return <MarkEmailReadIcon sx={{ color: green[600], ...iconSx }} />;
    case 'clicked':
      return <TouchAppIcon sx={{ color: green[700], ...iconSx }} />;
    case 'unsubscribed':
      return <UnsubscribeIcon sx={{ color: grey[600], ...iconSx }} />;
    case 'deferred':
      return <AccessTimeIcon sx={{ color: orange[400], ...iconSx }} />;
    case 'failed':
      return <ErrorOutlineIcon sx={{ color: red[500], ...iconSx }} />;
    case 'bounced':
      return <CancelIcon sx={{ color: red[600], ...iconSx }} />;
    case 'partial':
      return <RadioButtonCheckedIcon sx={{ color: orange[600], ...iconSx }} />;
    case 'draft':
      return <EditIcon sx={{ color: blue[400], ...iconSx }} />;
    default:
      return <PendingIcon sx={{ color: grey[400], ...iconSx }} />;
  }
};

export const getSmsCampaignStatusIcon = (status) => {
  switch (status) {
    case 'pending':
      return <PendingIcon sx={{ color: grey[500], ...iconSx }} />;
    case 'sending':
      return <HourglassBottomIcon sx={{ color: orange[500], ...iconSx }} />;
    case 'sent':
      return <CheckCircleIcon sx={{ color: green[500], ...iconSx }} />;
    case 'partial':
      return <WarningIcon sx={{ color: orange[600], ...iconSx }} />;
    case 'failed':
      return <ErrorOutlineIcon sx={{ color: red[500], ...iconSx }} />;
    case 'draft':
      return <EditIcon sx={{ color: blue[400], ...iconSx }} />;
    default:
      return <SmsIcon sx={{ color: grey[500], ...iconSx }} />;
  }
};

export const capitalizeStatus = (status) => {
  if (!status) return '';
  return status.charAt(0).toUpperCase() + status.slice(1);
};

export const smsRecipientCount = (campaign) =>
  campaign?.recipients?.length ?? 0;

export const smsCounts = (campaign) => ({
  sent: campaign?.counts?.sent ?? 0,
  delivered: campaign?.counts?.delivered ?? 0,
  failed: campaign?.counts?.failed ?? 0,
});
